<template>
  <div class="relative flex min-h-screen w-full flex-col items-center justify-center bg-background-light dark:bg-background-dark p-4">
    <p class="text-content text-title-sub font-normal">
      {{ $t('launch.processing') }}
    </p>
  </div>
</template>

<script setup>
  import { onMounted } from 'vue';
  import { useRoute, useRouter } from 'vue-router';
  import { useStore } from 'vuex';

  const route = useRoute();
  const router = useRouter();
  const store = useStore();

  onMounted(async () => {
    const launchToken = route.query.token;
    if (!launchToken) {
      router.replace('/login');
      return;
    }

    // History에서 전달한 Zone 정보 — 로그인 후 대시보드에서 자동 협업 Space에 사용
    const { appCode, requestNo, station, equipment } = route.query;
    if (requestNo || station || equipment) {
      sessionStorage.setItem(
        'launchZone',
        JSON.stringify({ requestNo, station, equipment }),
      );
    }

    const success = await store.dispatch('exchangeTokenLogin', { launchToken, appCode });
    if (!success) {
      router.replace('/login');
    }
  });
</script>
